export default "__VITE_ASSET__LCUayX3A__"